import React from 'react';
import styles from './ProtectedImage.module.css';

const ProtectedImage = ({ src, alt, className, ...props }) => {
  // Block right-click and long-press context menus
  const handleContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  // Block touch events that could lead to saving
  const handleTouchStart = (e) => {
    // Prevent long-press menu on touch devices
    if (e.touches && e.touches.length > 0) {
      // Allow normal scrolling/pinch but block context menu
      // We can't prevent default entirely or scrolling breaks,
      // so we rely on CSS `touch-action: none` and the overlay.
    }
  };

  return (
    <div className={`${styles.imageWrapper} ${className || ''}`}>
      <img
        src={src}
        alt={alt}
        onContextMenu={handleContextMenu}
        onTouchStart={handleTouchStart}
        draggable={false}
        {...props}
      />
      {/* Transparent overlay blocks all pointer/touch events on the image */}
      <div 
        className={styles.overlay} 
        onContextMenu={handleContextMenu}
        onTouchStart={(e) => e.preventDefault()}
      />
    </div>
  );
};

export default ProtectedImage;